import React from 'react';
import { Supplier } from '../../model/supplier';
import { entityManagerProvider } from '../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { PurchaseTransaction } from '../../model/purchase-transaction';
import { TransactionType } from '../../model/transaction-type';
import { DateInput } from '@progress/kendo-react-dateinputs';
interface PurchaseTranactionList {
  purchaseTranstions: PurchaseTransaction[];
  selected: PurchaseTransaction;
  suppliers: Supplier[];
  ids: number;
  loading: boolean;
  types: TransactionType[];
}

class PurchaseTransactions extends React.Component<
  any,
  PurchaseTranactionList
> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      purchaseTranstions: [] as PurchaseTransaction[],
      selected: null as PurchaseTransaction,
      suppliers: [] as Supplier[],
      ids: 0 as number,
      loading: true,
      types: [] as TransactionType[],
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addPurchaseTransaction = this.addPurchaseTransaction.bind(this);
    this.remove = this.remove.bind(this);
    this.cancleSelection = this.cancleSelection.bind(this);
    this.handleSupplierFilterChange = this.handleSupplierFilterChange.bind(
      this
    );
  }

  cancleSelection() {
    this.rejectChanges();
  }
  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('PurchaseTransactions').expand(
      'supplier, transactionType'
    );
    const queryTypes = new EntityQuery('TransactionTypes');
    const querySuppliers = new EntityQuery('Suppliers');
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        purchaseTranstions: qr.results,
        loading: false,
      });
      this.manager.executeQuery(querySuppliers).then((qr) => {
        this.setState({
          suppliers: qr.results,
        });
      });
      this.manager.executeQuery(queryTypes).then((qr) => {
        this.setState({
          types: qr.results,
        });
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }
  handleSupplierFilterChange(event) {
    this.setState({
      loading: true,
    });
    if (event.target.value !== '0') {
      const query = new EntityQuery('PurchaseTransactions')
        .where('supplierId', 'equals', event.target.value)
        .expand('supplier, transactionType');
      this.manager.executeQuery(query).then((qr) => {
        this.setState({
          selected: null,
          purchaseTranstions: qr.results,
          loading: false,
        });
      });
    } else {
      const query = new EntityQuery('PurchaseTransactions').expand(
        'supplier, transactionType'
      );
      this.manager.executeQuery(query).then((qr) => {
        this.setState({
          selected: null,
          purchaseTranstions: qr.results,
          loading: false,
        });
      });
    }
  }
  addPurchaseTransaction() {
    this.setState({
      ids: this.state.ids - 1,
    });
    let purchaseTransaction = this.manager.createEntity(
      PurchaseTransaction.prototype.entityType,
      {
        applicationUserId: this.props.authorizedUser.Id,
        createdOn: new Date(),
        modifiedOn: new Date(),
        purchaseTransactionId: this.state.ids,
      }
    ) as PurchaseTransaction;
    // purchaseTransaction.applicationUserId = this.props.authorizedUser.Id;
    // purchaseTransaction.createdOn = new Date();
    // purchaseTransaction.modifiedOn = new Date();
    // purchaseTransaction.purchaseTransactionId = this.state.ids;
    // select the new supplier, and add it to the list of suppliers
    this.setState({
      selected: purchaseTransaction,
      purchaseTranstions: this.state.purchaseTranstions.concat([
        purchaseTransaction,
      ]),
    });
  }

  remove(ent: PurchaseTransaction) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }

  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }

  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then((res) => {
        // refresh supplier list to remove deleted suppliers
        let purchase = this.manager.getEntities(
          'PurchaseTransaction'
        ) as PurchaseTransaction[];
        purchase = purchase.sort(
          (a, b) => a.purchaseTransactionId - b.purchaseTransactionId
        );
        this.setState({
          selected: null,
          purchaseTranstions: purchase,
          loading: false,
        });
      })
      .catch(function(error) {
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        const query = new EntityQuery('PurchaseTransactions');
        this.manager.executeQuery(query).then((res) => {
          this.setState({
            selected: null,
            purchaseTranstions: res.results,
            loading: false,
          });
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh supplier list to restore original state
    let purchase = this.manager.getEntities(
      'PurchaseTransaction'
    ) as PurchaseTransaction[];
    purchase = purchase.sort(
      (a, b) => a.purchaseTransactionId - b.purchaseTransactionId
    );
    this.setState({
      selected: null,
      purchaseTranstions: purchase,
    });
  }

  renderPaymentEdit() {
    let purchaseTransaction = this.state.selected;

    function handleTypeChange(event) {
      purchaseTransaction.transactionTypeId = event.target.value;
    }
    function handleSupplierChange(event) {
      purchaseTransaction.supplierId = event.target.value;
    }
    function changeValueDate(event) {
      purchaseTransaction.valueDate = event.value;
    }
    if (purchaseTransaction) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={
                  !this.manager.hasChanges() &&
                  this.state.selected.transactionTypeId > 0
                }
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, purchaseTransaction)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <Card.Title>Purchase Transaction Details</Card.Title>

              <form>
                <div className="form-group row">
                  <div className="col-lg-6">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="description"
                      value={purchaseTransaction.description || ''}
                      onChange={purchaseTransaction.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Amount</label>
                    <input
                      className="form-control"
                      type="number"
                      name="amount"
                      step="0.10"
                      value={purchaseTransaction.amount || ''}
                      onChange={purchaseTransaction.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>exChange Rate</label>
                    <input
                      className="form-control"
                      type="number"
                      name="exchangeRate"
                      step="0.10"
                      value={purchaseTransaction.exchangeRate || ''}
                      onChange={purchaseTransaction.handleChange}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label>Value</label>
                    <div className="from-control">
                      <DateInput
                        className="from-control"
                        name="valueDate"
                        format="dd/MM/yyyy"
                        value={purchaseTransaction.valueDate}
                        onChange={changeValueDate}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <label>Transaction Type</label>
                    <select
                      className="form-control"
                      name="transactionTypeId"
                      onChange={handleTypeChange}
                      value={purchaseTransaction.transactionTypeId || 0}
                    >
                      <option key={0}>Select Type</option>
                      {this.state.types?.map((type) => {
                        return (
                          <option
                            key={type.transactionTypeId}
                            value={type.transactionTypeId}
                          >
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    <label>Supplier</label>
                    <select
                      className="form-control"
                      name="supplierId"
                      onChange={handleSupplierChange}
                      value={purchaseTransaction.supplierId || 0}
                    >
                      <option key={0}>Select Supplier</option>
                      {this.state.suppliers?.map((supplier) => {
                        return (
                          <option
                            key={supplier.supplierId}
                            value={supplier.supplierId}
                          >
                            {supplier.supplierName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        {this.renderPaymentEdit()}
        <Card border="primary" style={{ width: '100%' }}>
          <Card.Header>
            <div className="row">
              <div className="col-md-6">
                <button
                  className="btn btn-primary ml-2"
                  type="button"
                  onClick={this.addPurchaseTransaction}
                >
                  <i className="fa fa-plus"></i>
                  Add Purchase Transaction
                </button>
                <button
                  className="btn btn-warning ml-2"
                  type="button"
                  onClick={this.cancleSelection}
                >
                  <i className="fa fa-undo"></i>
                  Cancel
                </button>
              </div>
              <div className="col-lg-4">
                <select
                  className="form-control"
                  name="supplierId"
                  onChange={this.handleSupplierFilterChange}
                >
                  <option key={0} value={0}>
                    Select Supplier
                  </option>
                  {this.state.suppliers?.map((supplier) => {
                    return (
                      <option
                        key={supplier.supplierId}
                        value={supplier.supplierId}
                      >
                        {supplier.supplierName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <Card.Title>
              Note:"Credit to increase Supplier Dues, Debit decrease supplier
              dues"
            </Card.Title>
            <div className="card card-custom card-stretch">
              {this.state.loading ? (
                <div className="row" style={{ minHeight: '200px' }}>
                  <Loader
                    size="large"
                    style={{ position: 'relative', margin: '60px auto' }}
                    type="converging-spinner"
                  />
                </div>
              ) : (
                <Table className="table" responsive="sm" bordered>
                  <thead>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>
                        <h5>Total</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.purchaseTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 1
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.purchaseTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 2
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5> Balance :</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.purchaseTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 2
                              ? acc + val.amount
                              : acc - val.amount;
                          }, 0)}
                        </h5>
                      </td>
                    </tr>
                    <tr>
                      <th>#</th>
                      <th>Description</th>
                      <th>Supplier</th>
                      <th>Credit</th>
                      <th>Debit</th>
                      <th>Rate</th>
                      <th>Value</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.purchaseTranstions &&
                      this.state.purchaseTranstions.map(
                        (purchaseTrans, idx) => {
                          return (
                            <tr
                              key={idx}
                              style={{
                                backgroundColor:
                                  purchaseTrans === this.state.selected
                                    ? 'lightgray'
                                    : 'white',
                              }}
                              onClick={() =>
                                this.setState({ selected: purchaseTrans })
                              }
                            >
                              <td>{purchaseTrans.purchaseTransactionId}</td>
                              <td>{purchaseTrans.description}</td>
                              <td>{purchaseTrans.supplier?.supplierName}</td>
                              <td>
                                {purchaseTrans.transactionType
                                  ?.transactionTypeId === 1
                                  ? purchaseTrans.amount
                                  : ''}
                              </td>
                              <td>
                                {purchaseTrans.transactionType
                                  ?.transactionTypeId === 2
                                  ? purchaseTrans.amount
                                  : ''}
                              </td>
                              <td>{purchaseTrans.exchangeRate}</td>
                              <td>
                                {this.dateFormatter(purchaseTrans.valueDate)}
                              </td>
                              <td>
                                {this.dateFormatter(purchaseTrans.createdOn)}
                              </td>
                            </tr>
                          );
                        }
                      )}
                    <tr>
                      <td></td>
                      <td></td>
                      <td>
                        <h5>Total</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.purchaseTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 1
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.purchaseTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 2
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5> Balance :</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.purchaseTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 2
                              ? acc + val.amount
                              : acc - val.amount;
                          }, 0)}
                        </h5>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default PurchaseTransactions;
